import { getApp } from '@genesislcap/foundation-shell/app';
import { css } from '@microsoft/fast-element';
import { optionTag, iconTag, flyoutTag } from '../tags';
/**
 * Base styles for the foundation-header
 *
 * @returns ElementStyles instance for the foundation-header
 *
 * @public
 */
export const MainStyles = css `
  :host {
    display: flex;
    flex-direction: row;

    --primary-gradient-angle: -113.5deg;
  }

  .dynamic-template {
    width: 100%;
  }

  .nav-listbox {
    background: var(--neutral-layer-2);
    display: flex;
    flex: 1;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0 0 15px 0 rgb(0 0 0 / 30%);
  }

  .nav-button {
    height: calc(var(--base-height-multiplier) * (var(--design-unit) - 1) * 1px);
    margin: 0;
  }

  .nav-leftside {
    background: var(--neutral-layer-2);
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left: calc(var(--design-unit) * 4px);
    gap: calc(var(--design-unit) * 2px);
  }

  .nav-leftside:focus-within {
    box-shadow: none;
  }

  ::slotted(${optionTag}),
  .nav-listbox .nav-leftside ${optionTag} {
    margin: 0 calc(var(--design-unit) * 2px);
    padding: 0 calc(var(--design-unit) * 2px);
    height: calc(var(--base-height-multiplier) * (var(--design-unit) - 1) * 1px + 2px);
    border-radius: calc(var(--control-corner-radius) * 1px);
    border: calc(var(--stroke-width) * 1px) solid
      color-mix(in srgb, var(--neutral-foreground-rest), transparent 90%);
  }

  ::slotted(${optionTag}.selected),
  .nav-leftside ${optionTag}.selected {
    background: color-mix(in srgb, var(--accent-fill-rest), transparent 95%);
    color: var(--neutral-foreground-rest);
  }

  ::slotted(${optionTag}:not(.selected)),
  .nav-leftside ${optionTag}:not(.selected) {
    background-color: color-mix(in srgb, var(--neutral-foreground-rest), transparent 90%);
    color: var(--neutral-foreground-rest);
  }

  ::slotted(${optionTag}:not(.selected):hover),
  .nav-leftside ${optionTag}:not(.selected):hover {
    background-color: color-mix(in srgb, var(--neutral-foreground-rest), transparent 95%);
    color: var(--neutral-foreground-rest);
  }

  .logout-container ${iconTag} {
    padding: 0 calc(var(--design-unit) * 3px);
  }

  .nav-visibility-icon {
    cursor: pointer;
    font-size: var(--type-ramp-plus-4-font-size);
    color: var(--neutral-fill-strong-rest);
    /* stylelint-disable-next-line property-no-vendor-prefix */
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .logo-container {
    display: flex;
    align-items: center;
  }

  .logo {
    height: calc(var(--design-unit) * 5px);
    width: calc(var(--design-unit) * 6px);
  }

  .nav-rightside {
    display: flex;
    flex: 1;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    margin-right: calc(var(--design-unit) * 4px);
    gap: calc(var(--design-unit) * 2px);
  }

  .icon-container {
    font-size: var(--type-ramp-plus-4-font-size);
    padding: calc(var(--design-unit) * 3px);
    color: var(--neutral-fill-strong-rest);
    cursor: pointer;
    position: relative;
  }

  .open-nav {
    width: 300px;
  }

  ::slotted(zero-tree-view),
  ::slotted(rapid-tree-view),
  ::slotted(foundation-tree-view) {
    --type-ramp-base-font-size: 12px;
  }

  ::slotted(div) {
    color: var(--accent-fill-rest);
    font-size: var(--type-ramp-minus-1-font-size);
    margin-bottom: calc(var(--design-unit) * 4px);
    padding-left: calc(var(--design-unit) * 4px);
    padding-right: calc(var(--design-unit) * 4px);
  }

  .nav-preferences {
    width: 100%;
    height: 25%;
    max-height: 250px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }

  .logout-container {
    align-items: center;
    background-color: var(--neutral-fill-rest);
    border: calc(var(--stroke-width) * 1px) solid
      color-mix(in srgb, var(--neutral-foreground-rest), transparent 90%);
    cursor: pointer;
    display: flex;
    flex-direction: row;
    height: 8%;
    max-height: 80px;
    padding: 3%;
  }

  .logout-container:hover {
    background-color: var(--neutral-fill-hover);
  }

  .language-selector {
    min-width: 80px;
    width: 80px;
  }

  .language-selector:hover,
  .language-selector:active,
  .language-selector:visited,
  .language-selector:focus-within {
    border-color: #333;
  }

  ${flyoutTag}::part(flyout), 
  ${flyoutTag}::part(footer) {
    padding: 0;
  }

  ${flyoutTag}::part(header),
  ${flyoutTag}::part(content) {
    padding: calc(var(--design-unit) * 2px);
  }

  .notifications-button {
    padding-right: calc((var(--design-unit) - 1) * 2px);
  }
`.withBehaviors(getApp().registerStylesTarget('header'));
